<template>
  <el-upload
    :action="filePath"
    :headers="header"
    name="file"
    list-type="picture-card"
    :file-list="fileList"
    :show-file-list="true"
    :on-preview="handlePreview"
    :class="{ disabled: uploadDisabled }"
    :on-remove="handleRemove"
    :before-upload="handleBeforeUpload"
    :on-success="(response, file, fileList) => uploadSuccess(response, file)"
    style="width: 100%"
    :data="{ code }"
  >
    <i class="el-icon-plus"></i>
    <div class="el-upload__tip" slot="tip" v-if="instructionText">{{ instructionText }}</div>
  </el-upload>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { getBase64, compressImage, base64ToFile } from '@/util/util'
  export default {
    props: {
      instructionText: {
        type: String,
        default: ''
      },
      file: {
        type: Array,
        default: () => []
      },
      isMultiple: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: 0
      },
      height: {
        type: Number,
        default: 0
      },
      // 大小限制(kb)
      fileSize: {
        type: Number,
        default: 800
      },
      // 压缩质量 0-1
      quality: {
        type: Number,
        default: 0.9
      },
      image: {
        type: String,
        default: ''
      },
      code: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        filePath: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        // filePath: 'https://custom-pre.ayundi.cn' + env.ferryUrl + '/oss/uploadV2',
        header: { Authorization: 'bearer ' + getToken() },
        fileList: [],
        uploadImg: '',
        uploadDisabled: false
      }
    },
    mounted() {
      this.fileList = this.file
    },
    watch: {
      fileList(val) {
        if (!this.isMultiple) {
          if (val.length > 0) {
            this.uploadDisabled = true
          }
        }
      }
    },
    methods: {
      handleBeforeUpload(file) {
        this.uploadDisabled = true
        // eslint-disable-next-line
        return new Promise(async (resolve, reject) => {
          const uploadTypes = ['jpg', 'jpeg', 'png', 'gif']
          const filetype = file.name.replace(/.+\./, '')
          if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
            this.$message.warning({
              message: '请上传后缀名为jpg、jpeg、png、gif的附件'
            })
            this.uploadDisabled = false
            reject(new Error('请上传后缀名为jpg、jpeg、png、gif的附件'))
            return
          }
          const isLt = file.size / 1024 < this.fileSize
          if (!isLt) {
            this.uploadDisabled = false
            this.$message.error(`上传图片大小不能超过${this.fileSize}kb!`)
            reject(new Error(`上传图片大小不能超过${this.fileSize}kb!`))
            return
          }
          if (this.width) {
            this.getImgSize(file).then(async (res) => {
              const { width, height } = res
              if (width !== this.width || height !== this.height) {
                this.$message.warning({
                  message: '尺寸不符，请修改尺寸后重新上传！'
                })
                this.uploadDisabled = false
                reject(new Error('尺寸不符，请修改尺寸后重新上传！'))
              } else {
                this.$loading()
                let compressFile = file
                const base64 = await getBase64(file)
                const compressBase64 = await compressImage(base64, 0.9)
                compressFile = base64ToFile(compressBase64, file.name)
                this.uploadDisabled = true
                resolve(compressFile)
              }
            })
          } else {
            this.$loading()
            let compressFile = file
            const base64 = await getBase64(file)
            const compressBase64 = await compressImage(base64, 0.9)
            compressFile = base64ToFile(compressBase64, file.name)
            resolve(compressFile)
          }
        })
      },
      uploadSuccess(res, file) {
        this.$loading().close()
        if (JSON.stringify(res.data) === '{}') {
          this.$message.warning({
            message: '请修改文件名后重新上传'
          })
          const index = this.$refs.uploadRef.uploadFiles.findIndex((e) => e.uid === file.uid)
          this.$refs.uploadRef.uploadFiles.splice(index, 1)
          this.uploadDisabled = false
          return
        }
        this.getImgSize(file.raw).then((resp) => {
          const { width, height } = resp
          this.uploadImg = res.data.url + `?width=${width}&height=${height}`
          this.$emit('uploadSuccess', this.uploadImg)
          if (!this.isMultiple) {
            this.uploadDisabled = true
          }
        })
      },
      // 上传失败
      handleUploadError() {
        this.$modal.msgError('上传失败，请重试')
        this.uploadDisabled = false
      },
      handleRemove(file, fileList) {
        this.uploadDisabled = false
        this.uploadImg = ''
        this.$emit('remove', this.uploadImg)
      },
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
